<template>
  <v-footer
    id="core-footer"
    absolute
    height="60"
  >
    <v-spacer />
    <span class="font-weight-light copyright">
      &copy;
      {{ (new Date()).getFullYear() }}
      <a
        href="https://www.seoulrobotics.org/"
        target="_blank"
        class="sr_gray--text"
      >Seoul Robotics</a>
      <small>  v2.2.0</small>
    </span>
  </v-footer>
</template>

<script>
  export default {

  }
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
